/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("AllowTagCreation4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class AllowTagCreation4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.AllowTagCreation4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.AllowTagCreation4STBehavior.prototype */ {
      __name: "AllowTagCreation4STBehavior",

      usedStyleAttributes: ["allowTagCreation"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (widget?.setAllowTagCreation) {
          const allowTagCreation = controller.getAnchorNode().getStyleAttribute("allowTagCreation");
          if (allowTagCreation) {
            widget.setAllowTagCreation(this.isSAYesLike(allowTagCreation));
          }
        }
      }
    };
  });
});
